import React, {  useContext, useEffect, useRef, useState } from "react";
import "./pageMenu.css"
import { AppContext } from "../../context/AppContext";
import {  MenuElement, MenuContentPage, MenuText, MenuTitle, MenuImg,LineSeparationSVG } from "../types/types";
import ornementImg from '../../image/Menu/ornement.webp'
import ornementImg2 from '../../image/Menu/ornement2.webp'
import bottomLine from '../../image/Menu/baseLine.webp'
import backMenu from '../../image/Menu/backMenu.webp'
import swooshtitle from '../../image/Menu/swoosh.webp'
import swooshtitleReverse from '../../image/Menu/swooshReverse.webp'
import { MdOutlinePhotoCamera } from "react-icons/md";

function isTextOrTitle(
  el: MenuElement
): el is MenuText | MenuTitle {
if('type' in el) {
  return el.type === 'text' || el.type === 'title';
} else {
    return false}
}

const PageOrnaments = React.memo(function PageOrnaments({
  StyleMenu,
  front,
}: {
  StyleMenu: number;
  front: boolean;
}) {
  return <>{front  ? 
                            StyleMenu === 0 ? <>
                                <div className="topRight ornement1 firstWidth" ></div>
                                <div className="topRight2 ornement2 scndWidth" ></div>
                                <div className="topRight ornement1 firstHeight" ></div>
                                <div className="topRight2 ornement2 scndHeight" ></div>
            
                                <div className="bottomRight ornement1 firstWidth"  ></div>
                                <div className="bottomRight2 ornement2 scndWidth" ></div>
                                <div className="bottomRight ornement1 firstHeight" ></div>
                                <div className="bottomRight2 ornement2 scndHeight" ></div>
                                <div className="borderStyle2"></div>
                            </>
                                : StyleMenu === 1  ? <>
                                        <div className="topLeftProx" style={{aspectRatio:'1/1'}}>
                                            <img src={ornementImg} loading="lazy" alt="ornement"/>
                                        </div>
                        
                                        <div className="bottomLeftProx"  style={{aspectRatio:'1/1'}}>
                                            <img src={ornementImg} loading="lazy" alt="ornement"/>
                                        </div>
                                    </>
                                : StyleMenu === 2 ? <>
                                    <img className="bottomLine" src={bottomLine} loading="lazy" alt="ligne"/>
                                    <div className="borderStyle2"></div>
                                </> : StyleMenu === 4 ? <>
                                    <div className="lineHorizontalStyle style4 isTop isFirst firstGradient"></div>
                                    <div className="lineHorizontalStyle style4 isTop isScnd scndGradient"></div>
                                    <div className="lineHorizontalStyle style4 isBottom isFirst firstGradient"></div>
                                    <div className="lineHorizontalStyle style4 isBottom isScnd scndGradient"></div>
                                    <div className="lineVerticalStyle style4 isLeft scndGradient"></div>
                                    <div className="lineVerticalStyle style4 isRight firstGradient"></div>
                                    <div className="decorationStyle4 isTop" style={{top:'12px'}}></div>
                                    <div className="decorationStyle4 isBottom" style={{bottom:'2px'}}></div>
                                </>
                                : StyleMenu === 5 && <>
                                    <div className="topLeftProx style5" style={{width:'10%'}}>
                                        <img src={ornementImg2} loading="lazy" alt="ornement"/>
                                    </div>
                                    <div className="bottomLeftProx style5"  style={{width:'10%'}}>
                                        <img src={ornementImg2} loading="lazy" alt="ornement"/>
                                    </div>
                                    <div className="topRightProx style5" style={{width:'10%'}}>
                                        <img src={ornementImg2} loading="lazy" alt="ornement"/>
                                    </div>
                    
                                    <div className="bottomRightProx style5"  style={{width:'10%'}}>
                                        <img src={ornementImg2} loading="lazy" alt="ornement"/>
                                    </div>
                                    <div className="lineHorizontalStyle isTop scndGradient"></div>
                                    <div className="lineHorizontalStyle isBottom firstGradient"></div>
                                    <div className="lineVerticalStyle isLeft scndGradient"></div>
                                    <div className="lineVerticalStyle isRight firstGradient"></div>
                                </>
                        :
                        StyleMenu === 0 ? <>
                            <div className="topLeft ornement1 firstWidth" ></div>
                            <div className="topLeft2 ornement2 scndWidth" ></div>
                            <div className="topLeft ornement1 firstHeight" ></div>
                            <div className="topLeft2 ornement2 scndHeight" ></div>
        
                            <div className="bottomLeft ornement1 firstWidth"  ></div>
                            <div className="bottomLeft2 ornement2 scndWidth" ></div>
                            <div className="bottomLeft ornement1 firstHeight" ></div>
                            <div className="bottomLeft2 ornement2 scndHeight" ></div>
                            <div className="borderStyle2"></div>
                        </> : StyleMenu === 1 ? <>
                            <div className="topLeftProx" style={{aspectRatio:'1/1'}}>
                                <img src={ornementImg} loading="lazy" alt="ornement"/>
                            </div>
            
                            <div className="bottomLeftProx"  style={{aspectRatio:'1/1'}}>
                                <img src={ornementImg} loading="lazy" alt="ornement"/>
                            </div>
                        </>
                        : StyleMenu === 2 ? <>
                            <img className="bottomLine" src={bottomLine} loading="lazy" alt="ligne"/>
                            <div className="borderStyle2"></div>
                        </> : StyleMenu === 4 ? <>
                                <div className="lineHorizontalStyle style4 isTop isFirst firstGradient"></div>
                                <div className="lineHorizontalStyle style4 isTop isScnd scndGradient"></div>
                                <div className="lineHorizontalStyle style4 isBottom isFirst firstGradient"></div>
                                <div className="lineHorizontalStyle style4 isBottom isScnd scndGradient"></div>
                                <div className="lineVerticalStyle style4 isLeft scndGradient"></div>
                                <div className="lineVerticalStyle style4 isRight firstGradient"></div>
                                <div className="decorationStyle4 isTop" style={{top:'12px'}}></div>
                                <div className="decorationStyle4 isBottom" style={{bottom:'2px'}}></div>
                            </>
                            : StyleMenu === 5 && <>
                                    <div className="topLeftProx style5" style={{width:'10%'}}>
                                        <img src={ornementImg2} loading="lazy" alt="ornement"/>
                                    </div>
                                    <div className="bottomLeftProx style5"  style={{width:'10%'}}>
                                        <img src={ornementImg2} loading="lazy" alt="ornement"/>
                                    </div>
                                    <div className="topRightProx style5" style={{width:'10%'}}>
                                        <img src={ornementImg2} loading="lazy" alt="ornement"/>
                                    </div>
                    
                                    <div className="bottomRightProx style5"  style={{width:'10%'}}>
                                        <img src={ornementImg2} loading="lazy" alt="ornement"/>
                                    </div>
                                <div className="lineHorizontalStyle isTop scndGradient"></div>
                                <div className="lineHorizontalStyle isBottom firstGradient"></div>
                                <div className="lineVerticalStyle isLeft scndGradient"></div>
                                <div className="lineVerticalStyle isRight firstGradient"></div>
                        </>}</>
});


interface interfacePageMenu {
    content : MenuContentPage,
    index: number,
    front: boolean,
    StyleMenu: number,
    pageShow:number,
    isInteract:boolean,
    frontTel:boolean,
    isPhone?:boolean,
}

const PageMenuBase:React.FC<interfacePageMenu> = ({content,index,front,StyleMenu=-1,pageShow,isInteract,frontTel,isPhone=false}) => {
    const {setShowPlat} = useContext(AppContext)
    
    const handleClick = (idLine?:number,name?:string) => {
        if(name) {
            setShowPlat([index,frontTel?0 : 1,idLine ||0])
        }
        else setShowPlat([-1,0,0])
    }
    const isActive = Math.abs(pageShow - index) <= 1;
    const [keepVisible, setKeepVisible] = useState(false);

    useEffect(() => {
        let timeoutId: number | undefined;

        if (isActive) {
            setKeepVisible(true);
        } else {
            timeoutId = window.setTimeout(() => {
            setKeepVisible(false);
            }, 700);
        }

        return () => {
            if (timeoutId) window.clearTimeout(timeoutId);
        };
    }, [isActive]);

    const refPage = useRef<HTMLDivElement>(null)
    const [priceWidths, setPriceWidths] =  useState<Record<number, number>>({});
    const priceRefs = useRef<Record<number, HTMLParagraphElement | null>>({});
    const [pageDimensions, setPageDimensions] = useState<{ width: number; height: number }>({
        width: 432,   
        height: 300,
    });

    useEffect(() => {
        if(!keepVisible) return
        const measure = () => {
            if (!refPage.current) return;
            const el = refPage.current;
            const width = el.clientWidth || 432;
            const height = el.clientHeight || 300;
            setPageDimensions({ width, height });
        };
        measure();

        window.addEventListener("resize", measure);
        return () => {
            window.removeEventListener("resize", measure);
        };
    }, [keepVisible]);

    useEffect(() => {
        if (!isActive || !Object.keys(priceRefs.current).length) return;
        const rafId = requestAnimationFrame(() => {
            const newWidths: Record<number, number> = {};
            Object.entries(priceRefs.current).forEach(([key, el]) => {
            if (el) newWidths[Number(key)] = el.clientWidth / 1.1261;
            });
            setPriceWidths(newWidths);
        });

        return () => cancelAnimationFrame(rafId);
    }, [content, isActive, keepVisible]); 

    const { lines, imgs } = React.useMemo(() => {
        const lines: Array<MenuElement> = [];
        const imgs:  Array<MenuImg> = [];
        (content?.elements ?? []).forEach((el, idx) => {
            (el?.type === 'img' ? imgs : lines).push(el);
        });
        return { lines, imgs };
    }, [content]);


    const basePageWidth = 0.3 * 1440;
    const pageScale = pageDimensions.width / basePageWidth;
    const pageHeight = pageDimensions.height;
    const fontSizeToDvw = (value:number): number => {
        const baseFontSize = value/2; 
        return baseFontSize * pageScale - 0.005;
    }

    return (<div className={`containerPageMenu ${front ? 'PageMenuFront' : 'PageMenuBack'}  style${StyleMenu} ${isInteract ? 'interactPage' : ''}`} ref={refPage}  >
            {keepVisible && <img src={StyleMenu === 3 && (content.imgback?.url || '') ? content.imgback?.url : backMenu} {...(index===0 && !front ? { fetchpriority: 'high' } : {})}  className={`${content.imgback ? (content.imgback.iscropp ? 'isCropped' : 'isAuto') : ''} backgroundMenu`}  alt=""/> }
            <div className={`filterCover${StyleMenu}`}></div> 
            {keepVisible && <>
                {
                    imgs && imgs.length > 0  && imgs.map((line,id) => {
                        return <img key={'imgMenu'+id} className="containerLineMenuImg" src={line.props.url}
                         style={{...(front ? {left:`${line.props.left || 0}%`} : {right:`${line.props.left || 0}%`}),top:`${line.props.top || 0}%`,width: `${line.props.width || 30}%`,...('borderRadius' in line.props ? {borderRadius: `${line.props.borderRadius}px`} : {}),...('opacity' in line.props ? {opacity: `${100-(line.props.opacity || 0)}%`} : {}),...('border' in line.props ? {border:`${line.props.border}px solid ${'borderColor' in line.props ? line.props.borderColor : '#000000'}`} : {}) }} loading="lazy" alt="decoration"/>
                    })
                }
                <PageOrnaments StyleMenu={StyleMenu} front={front}/>
                </>
            }                       
            <div className={`${front ? 'front-content' : 'back-content'}  ${pageShow !== index && 'notShowTel'}`} >
                {
                    keepVisible && lines && lines.length > 0 && lines.map((line,idLine) => {
                        const isShowPrice = line.type === 'text' && line.props.price && line.props.price !== '-1';
                        const isMargin = line.type === 'text' && ( line.props.marginLeft || line.props.marginRight)
                        const isMarginLeft = line.type === 'text' ? ( line.props.marginLeft || 0) : 0
                        const isMarginRight = line.type === 'text' ? ( line.props.marginRight || 0) : 0
                        const spaceHeight = line.type === "space" ? (pageHeight / 100) * (15 * ((line.props.size || 50) / 100)) : undefined;
                        return (
                             <div className={`containerLineMenu  ${line.type === 'title' ? 'smallTitle' : 'smallText'} ${line.type === 'separation' ? 'isSeparationLine' : ''} ${line.type === 'space' ? 'isSpaceLine' : ''} ${line.type === 'text' ? ('image' in line.props && line.props.image !== '' && isInteract ? 'pointer isText underLineHover' : 'default isText') : 'default'}`}key={'lineMenu'+idLine} onClick={(e) => {if(line.type === 'text' && line.props.image){e.stopPropagation()};handleClick(idLine,((line.type === 'text' && line.props.image) ? line.props.text : ''))}} style={{height:line.type === 'space' ?  `${spaceHeight}px` : 'auto',minHeight: line.type === 'space' ?  `${spaceHeight}px` : 'none',
                                color: isTextOrTitle(line) ? (line.props.color || 'black') : 'black',fontStyle: isTextOrTitle(line) ? (line.props.italic ? 'italic' : 'normal') : 'normal',fontWeight: line.type === 'text' ? (line.props.bold ? 'bold' : '') : '',
                                fontSize: isTextOrTitle(line) ? `${fontSizeToDvw(line.props.fontSize || (line.type === 'text' ? 20 : 28))}px` : '20px',justifyContent: (line.type === 'title' && line.props.alignement) ? (line.props.alignement === 'left' ? 'start' : (line.props.alignement === 'right' ? 'end' : 'center')) : 'center', 
                                ...(isMargin ? {marginLeft:`${isMarginLeft}%`,marginRight:`${isMarginRight}%`,width:`${100-isMarginLeft-isMarginRight}%`} : {}), ...(line.type === 'separation' ? {justifyContent: line.props.alignement ||'center'} : {})}}  >
                            {
                                line.type === 'text' ? 
                                <>
                                    <div className="contentText" style={content.fontfamilytext ? {fontFamily:content.fontfamilytext} : {}}>
                                        {(line.type === 'text' &&  line.props.image && isInteract) &&  <MdOutlinePhotoCamera className="interactivePoint"/> }
                                        <p className=" text" style={{marginLeft: line.props.alignement === 'center' ? priceWidths[idLine] || '0' : '0',textAlign:isTextOrTitle(line) ? (line.props.alignement || 'left') : 'left'}}>{line.props.text}</p>
                                        {isShowPrice && 
                                            <p className=" price"  ref={(el) => (priceRefs.current[idLine] = el)}>{line.props.price}€</p>
                                        }
                                    </div>
                                    {('visibleDesc' in line.props && line.props.visibleDesc) &&   <p className="descText" style={{color:line.props.colorDesc ||'#999799',fontSize: `${fontSizeToDvw((line.props.fontSizeDesc || 18))}px`,fontWeight:line.props.boldDesc ? 'bold' : 'normal',fontStyle: 'italicDesc' in line.props ? '' : 'italic',textAlign:isTextOrTitle(line) ? (line.props.alignement || 'left') : 'left',...(content.fontfamilytext ? {fontFamily:content.fontfamilytext} : {})}}>{line.props.description || ''}</p>}
                                </>
                                :
                                line.type === 'title' ?
                                    <>
                                    {line.props.style && <>{
                                        line.props.style === 1 ?
                                                (line.props.alignement || 'center') !== 'left' && <div className="leftLineTitle"></div>
                                                : (line.props.style === 2 && (line.props.alignement || 'center') !== 'left') &&  <img className="swooshTitle" src={swooshtitle} alt="swooshTitle"/>
                                    }</> }      
            
                                    <div className="text "   style={{textAlign:isTextOrTitle(line) ? (line.props.alignement || 'center') : 'center',...(content.fontfamilytitle ? {fontFamily:content.fontfamilytitle} : {}),fontWeight:'bold' in line.props ? 500 : 600}}>
                                        {line.props.text}
                                        {line.props.style === 3 && <img className="bottomLine" src={bottomLine} alt="lineTitle"/>}
                                    </div>
                                    
                                    {line.props.style && <>{
                                        line.props.style === 1 ?
                                        <div className="rightLineTitle"></div>
                                        : (line.props.style === 2 && (line.props.alignement || 'center') !== 'right') && <img className="swooshTitle" src={swooshtitleReverse} alt="swooshTitle"/>
                                        }</>}
                                        
                                    </> : line.type === 'separation' && <LineSeparationSVG
                                            thickness={line.props.height || 1}
                                            color={line.props.color || '#000000'}
                                            wave={line.props.wave || 0}    
                                            type={line.props.type || 0}
                                            width={line.props.width || 80}
                                            gradient={line.props.degrade || false}
                                        />
                            }
                        </div>
                        )
                    })
                }
            </div>
        </div>
    )
}
const PageMenu = React.memo(PageMenuBase, (prev, next) => {
    return (
        prev.index === next.index &&
        prev.pageShow === next.pageShow &&
        prev.front === next.front &&
        prev.isInteract === next.isInteract &&
        prev.frontTel === next.frontTel &&
        prev.StyleMenu === next.StyleMenu &&
        prev.content === next.content
    );
});


export { PageMenu };